import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const restoreServiceType = ({ _id }: { _id: string }): Promise<void> => {
  return axios.post(`/service-types/${_id}/restore`);
};

type UseRestoreServiceTypeOptions = {
  config?: MutationConfig<typeof restoreServiceType>;
};

const TOAST_ID = 'restore-service-type';

export const useRestoreServiceType = ({ config = {} }: UseRestoreServiceTypeOptions = {}) => {
  return useMutation({
    ...config,
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['service-types']);
      toasts.loadingToast.success(TOAST_ID, 'Service type restored');
      config.onSuccess?.(...params);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error(TOAST_ID, serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading(TOAST_ID, 'Restoring...');
      config.onMutate?.(...args);
    },
    mutationFn: restoreServiceType,
  });
};
